import { render, staticRenderFns } from "./Apollo.vue?vue&type=template&id=ac7e4e52&"
import script from "./Apollo.vue?vue&type=script&lang=ts&"
export * from "./Apollo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports